import auth from '@/services/auth';
import { assumedOrgState } from '@/services/assumedOrg';

const STAFF_ROLES = ['PLATFORM_ADMIN', 'PLATFORM_ENGINEER'];
const CLIENT_ADMIN_ROLES = ['ORG_ADMIN', 'HEALTHCARE_ADMIN', 'ADMIN'];

export function isRealPlatformStaff() {
  return STAFF_ROLES.includes(auth.getUserRole());
}

/** Staff previewing a client role through View As. */
function staffViewingAsClient() {
  return !!(
    isRealPlatformStaff()
    && assumedOrgState.org
    && assumedOrgState.role
    && !STAFF_ROLES.includes(assumedOrgState.role)
  );
}

/** True when Org Setup should show the client (view-only, Profile editable) screen. */
export function orgSetupClientView() {
  return !isRealPlatformStaff() || staffViewingAsClient();
}

/** Org id a client admin may open in Org Setup, or null. */
export function clientOrgSetupOrgId() {
  let isAdmin;
  if (isRealPlatformStaff()) {
    isAdmin = staffViewingAsClient() && CLIENT_ADMIN_ROLES.includes(assumedOrgState.role);
  } else {
    isAdmin = CLIENT_ADMIN_ROLES.includes(auth.getUserRole()) || !!auth.getUser()?.is_organization_admin;
  }
  if (!isAdmin) return null;
  const org = assumedOrgState.org || auth.getUserOrganization();
  return org?.id || null;
}
